import React from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const chip = tv({
  base: "flex size-fit items-center justify-center",
  variants: {
    color: {
      default: "bg-default text-text-primary",
      secondary: "bg-secondary text-text-primary",
      background: "bg-background-2 text-text-primary",
      success: "bg-secondary text-[#7BCB5E]",
      danger: "bg-secondary text-danger",
      tertiary: "bg-tertiary text-text-primary",
      primary: "bg-background text-primary",
    },
    size: {
      sm: "px-2 py-1 text-xs",
      md: "px-2 py-1 text-sm",
      lg: "px-3 py-2 text-base",
    },
    rounded: {
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-xl",
      full: "aspect-square rounded-full",
    },
    border: {
      none: "",
      dashed: "border border-dashed border-border",
    },
    variant: {
      default: "",
      ghost: "bg-transparent",
      bordered: "border border-border",
      "ghost-bordered":
        "rounded-md border border-border bg-background/20 px-3 py-2",
    },
  },
  defaultVariants: {
    size: "md",
    color: "default",
    rounded: "lg",
    border: "none",
    variant: "default",
  },
});

export default function Chip({
  children,
  size,
  className,
  color,
  border,
  rounded,
  variant,
  prefix,
}: {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly prefix?: string;
} & VariantProps<typeof chip>) {
  return (
    <div className={chip({ size, color, className, border, rounded, variant })}>
      {prefix && (
        <span
          className={`text-text-secondary mr-2.5 text-sm break-keep whitespace-nowrap`}
        >
          {prefix}
        </span>
      )}
      {children}
    </div>
  );
}
